import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'carbon-components-react'

const MfaRememberMe = ( { rememberMeCheck } ) => {

    const [ isChecked, setIsChecked ] = useState( false )

    const handleRememberMeCheck = ( checked ) => {
        setIsChecked( checked ) 
        rememberMeCheck ( checked )
    }

  return (
      <>
          <div className='mb-2 mfa-remember-device-container'>
              <Checkbox id='mfa-remember-device' data-testid='mfa-remember-device' tabIndex={ 0 } className='mfa-remember-me-checkbox' alt='Remember Me' checked={ isChecked } onChange={ ( checked ) => handleRememberMeCheck( checked ) } labelText='Remember this browser for 45 days' aria-label='Remember this browser for 45 days'></Checkbox>
          </div> 
          <div className='mb-2'>
              <label tabIndex='0' className='mb-0 mfa-remember-device-label'>Select this only if you're on a trusted device</label>
          </div> 
      </> 
  )
}

export default MfaRememberMe

MfaRememberMe.propTypes = {
    rememberMeCheck: PropTypes.func
}
